module.exports = __webpack_public_path__ + "static/media/libry.b68965b3.png";